import { useQuery } from '@tanstack/react-query'
import { api } from '@/utils/api'
import { apiBundles } from '@/utils/api/url'
import { Bundle } from '@/types/bundle'

export const QUERY_KEY_GET_BUNDLES = 'QUERY_KEY_GET_BUNDLES'
export const useGetBundles = ({ enabled = true }: { enabled: boolean }) => {
  const res = useQuery({
    enabled: enabled,
    staleTime: 60 * (60 * 1000), // 60mins
    queryKey: [QUERY_KEY_GET_BUNDLES],
    queryFn: () =>
      api.get(apiBundles).then(({ data }) => {
        const res = data as Bundle[]
        return res
      }),
  })
  return res
}
